import { TOAST } from './actionType';

export const toast = (message, status, isError = false) => dispatch => {
  dispatch({
    type: TOAST,
    payload: { message: message, status: status, isError: isError }
  });
};
